import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';

const WhyToCare = ({
    title
}) => {

    const iconFileName = "wave-hitting-home-icon-grey.png"
    const iconUrl = CreateCloudfrontUrl(iconFileName);

    const introSentence = "No home is an island and you can be swept up in market forces that impact your home’s value. Climate can be a more extreme factor than others, even when disasters strike outside of your direct area. That said, as climate risk intensifies, for some markets it will be a drag, while others may see a boost. Understanding the role climate is playing in this market is critical."

    return (
        <div className="ltv-market-signals-section-container">
            <h2 className="ltv-attractiveness-title">{title}</h2>
            <div className="ltv-market-signals-section-container-icon">
                <img src={iconUrl} alt="Qoll - Wave hitting home" />
            </div>
            <p className="ltv-market-signals-section-container-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: introSentence }} />
        </div>
    );
};

export default WhyToCare;